import { FONT } from "@/styles/fonts"
import { themeColors } from "@/styles"
import { makeStyles } from "@/utils/makeStyles"

const useStyles = makeStyles(() => ({
	container: {
		width: "100%",
		border: `1px solid ${themeColors.colors.system.gray[100]}`,
		borderRadius: "0.5rem"
	},
	headerCell: {
		backgroundColor: themeColors.colors.system.gray[100],
		fontWeight: FONT.fontWeight.semibold,
		padding: "1rem"
	},
	bodyCell: {
		padding: "1rem",
		borderBottom: `1px solid ${themeColors.colors.system.gray[100]}`
	},
	skeletonCell: {
		padding: "1rem"
	},
	emptyStateContainer: {
		display: "block",
		textAlign: "center",
		padding: "2rem"
	}
}))

export default useStyles
